import { useCallback, useMemo, useState } from 'react';
import {
  DevCycleUserIdentity,
  useIdentifyUser,
} from 'src/hooks/useIdentifyUser';
import {
  getAnonymousDevCycleUserIdentity,
  getLoadingDevCycleUserIdentity,
} from 'src/utilities/devCycleUserIdentity';

export interface DevCycleUserIdentityController {
  setLoading: () => void;
  setAnonymous: () => void;
  setIdentity: (identity: DevCycleUserIdentity) => void;
  resetUser: () => Promise<void>;
}

export const useDevCycleUserIdentity = (): DevCycleUserIdentityController => {
  const [identity, setIdentity] = useState<DevCycleUserIdentity>(
    getLoadingDevCycleUserIdentity
  );

  const resetDevCycleUser = useIdentifyUser(identity);

  const resetUser = useCallback(async (): Promise<void> => {
    setIdentity(getAnonymousDevCycleUserIdentity());
    await resetDevCycleUser();
  }, [resetDevCycleUser]);

  return useMemo(
    () => ({
      setLoading: () => setIdentity(getLoadingDevCycleUserIdentity()),
      setAnonymous: () => setIdentity(getAnonymousDevCycleUserIdentity()),
      setIdentity,
      resetUser,
    }),
    [resetUser]
  );
};
